// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Schema to represent key information for module requests
 */
export interface ModuleRequest {
  moduleId: string;
  createdOn: string;
  lecturerId: string;
  authorName: string;
  moduleTitle: string;
}
